import React, {useState} from 'react';
import sortBy from 'lodash/sortBy'

import {Menu, MenuItem} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NestedMenuItem from 'material-ui-nested-menu-item';
import Checkbox from '@material-ui/core/Checkbox';

export default function CategoriesSelect(props) {
  const {
    categoryTreeList,
    handleToggle,
    checked,
    setMenuPosition,
    menuPosition,
    closeCallback
  } = props;
  const handleItemClick = (event) => {
    // setMenuPosition(null);
  };

  const returnItem = (cat, depth) => {
    return (
      <MenuItem
        key={cat.id}
        // onClick={handleItemClick}
        onClick={(e) => handleToggle(e, cat.id, cat.name)}
        style={{paddingLeft: 24}}
      >
        <FormControlLabel
          // onClick={(e) => handleToggle(e, cat.id, cat.name)}
          control={
            <Checkbox
              edge="start"
              checked={checked.indexOf(cat.id) !== -1}
              tabIndex={-1}
              disableRipple
              inputProps={{
                'aria-labelledby': `checkbox-category-tree-${cat.id}`,
              }}
            />
          }
          label={cat.name}
        />
      </MenuItem>
    );
  };

  const returnNestedItem = (cat, depth) => {
    return (
      <NestedMenuItem
        style={{paddingLeft: 24}}
        label={
          <FormControlLabel
            // onClick={(e) => handleToggle(e, cat.id, cat.name)}
            control={
              <Checkbox
                edge="start"
                checked={checked.indexOf(cat.id) !== -1}
                tabIndex={-1}
                disableRipple
                inputProps={
                  {
                    // 'aria-labelledby': `checkbox-list-secondary-label-${subCategory.id}`,
                  }
                }
              />
            }
            label={cat.name}
          />
        }
        parentMenuOpen={!!menuPosition}
        // onClick={handleItemClick}
        onClick={(e) => handleToggle(e, cat.id, cat.name)}
      >
        {cat.subCategories
          ? sortBy(cat.subCategories, o => o.name).map((subCat) => nestSplitter(subCat, depth + 1))
          : returnItem(cat, depth + 1)}
      </NestedMenuItem>
    );
  };

  const nestSplitter = (category, depth) => {
    // return nested menu for categories that have a subcategory
    if (depth === 1 || category.depth === depth) {
      return category.subCategories
        ? returnNestedItem(category, depth)
        : returnItem(category, depth);
    }
  };

  const handleClose = () => {
    setMenuPosition(null)
    if (closeCallback) {
      closeCallback()
    }
  }  

  return (
    <div>
      <Menu
        open={!!menuPosition}
        onClose={() => handleClose()}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
      >
        {categoryTreeList && sortBy(categoryTreeList, o => o.name).map((category) => nestSplitter(category, 1))}
      </Menu>
    </div>
  );
}
